export function createClientId(): string {
  const browserCrypto = globalThis.crypto as Crypto | undefined;
  if (typeof browserCrypto?.randomUUID === 'function') return browserCrypto.randomUUID();
  if (typeof browserCrypto?.getRandomValues === 'function') {
    const bytes = new Uint8Array(16);
    browserCrypto.getRandomValues(bytes);
    return Array.from(bytes, (value) => value.toString(16).padStart(2, '0')).join('');
  }
  return `client-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 14)}`;
}
